/**
 * UI palette (docs/11-ux-ui.md §2). Tier hues follow the bot except Common:
 * the bot's yellow reads as "legendary", so Common is slate here (display only).
 */
export interface TierStyle {
  base: string;
  light: string;
  dark: string;
}

export const TIER_STYLES: Record<number, TierStyle> = {
  1: { base: '#8f9bb0', light: '#c9d1de', dark: '#4b5466' },
  2: { base: '#4fb97a', light: '#a6e6bf', dark: '#1f5c3a' },
  3: { base: '#4b84e6', light: '#a9c6ff', dark: '#1d3d7a' },
  4: { base: '#a35ee0', light: '#d8b4ff', dark: '#4e2675' },
  5: { base: '#f0a33a', light: '#ffd794', dark: '#7a4a10' },
  6: { base: '#38c6dc', light: '#a8f0fb', dark: '#0f5b68' },
  7: { base: '#ec4f7d', light: '#ffb0c7', dark: '#7a1735' },
};

export function tierStyle(tier: number): TierStyle {
  return TIER_STYLES[tier] ?? (TIER_STYLES[1] as TierStyle);
}

/** Dofus canon: Strength = Earth, Intelligence = Fire, Chance = Water, Agility = Air. */
export const ELEMENT_COLORS: Record<string, string> = {
  Neutral: '#9aa0ad',
  Strength: '#b9813a',
  Intelligence: '#e2553b',
  Chance: '#3a8ee6',
  Agility: '#3fb57a',
  Multi: '#a26ae0',
};

export const ELEMENT_HUES: Record<string, number> = {
  Neutral: 230,
  Strength: 32,
  Intelligence: 8,
  Chance: 212,
  Agility: 148,
  Multi: 275,
};

export function elementColor(element: string): string {
  return ELEMENT_COLORS[element] ?? '#9aa0ad';
}
